// One choice out of a fixed set, remembered in this browser across reloads — a per-viewer
// convenience (the board's client / internal filter), never shared state. A stored value
// outside the set, or storage that throws (private mode), falls back to the default.
import { useState } from 'react';

const read = (key, allowed, fallback) => {
  try {
    const value = window.localStorage.getItem(key);
    return allowed.includes(value) ? value : fallback;
  } catch {
    return fallback;
  }
};

export default function useStoredChoice(key, allowed, fallback) {
  const [value, setValue] = useState(() => read(key, allowed, fallback));
  const choose = (next) => {
    setValue(next);
    try { window.localStorage.setItem(key, next); } catch { /* not remembered — fine */ }
  };
  return [value, choose];
}
